import { HStack } from '@chakra-ui/react';
import {
  PageHeader as GammaPageHeader,
  PageHeaderProps as GammaPageHeaderProps,
} from '@gamma/ui/layout';
import { ReactNode, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { FederatedTenantSelect } from '@investigator/features/detections/components';

export interface PageHeaderProps extends GammaPageHeaderProps {
  children?: ReactNode;
  isLoading?: boolean;
  totalItems?: number;
  onDateRangeChange?: () => void;
}

export const PageHeader = ({
  children,
  isLoading,
  onDateRangeChange,
  ...rest
}: PageHeaderProps) => {
  const navigate = useNavigate();

  const { search, pathname } = useLocation();

  const params = useMemo(() => new URLSearchParams(search), [search]);

  return (
    <GammaPageHeader
      {...rest}
      actions={
        <HStack>
          <FederatedTenantSelect
            params={params}
            navigate={navigate}
            pathname={pathname}
          />
        </HStack>
      }
      variant="flushed"
    >
      {children}
    </GammaPageHeader>
  );
};
